module.exports = __webpack_public_path__ + "img/logo-header-white.2e44f6a6.png";